import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FT_PI_HREFLANG_ATTRIBUTE, FS_ENABLE_SEO_BREADCRUMB_PI } from '@whitbread-eos/api';
import { formatAssetsUrl, removeHtmlTags, useFeatureToggle, useFeatureSwitch, useCustomLocale, containsPlaceLD, getPriceRange } from '@whitbread-eos/utils';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function faqFormatter(faqItems) {
  var _faqItems$map;
  return (_faqItems$map = faqItems.map(faqItem => {
    var _faqItem$question, _faqItem$answer;
    return JSON.stringify({
      '@type': 'Question',
      name: (_faqItem$question = faqItem === null || faqItem === void 0 ? void 0 : faqItem.question) !== null && _faqItem$question !== void 0 ? _faqItem$question : '',
      acceptedAnswer: {
        '@type': 'Answer',
        text: removeHtmlTags((_faqItem$answer = faqItem === null || faqItem === void 0 ? void 0 : faqItem.answer) !== null && _faqItem$answer !== void 0 ? _faqItem$answer : '').replace(/(\r\n|\n|\r)/gm, ' ').trim()
      }
    });
  })) === null || _faqItems$map === void 0 ? void 0 : _faqItems$map.join(',');
}
export default function SEO(_ref) {
  var _breadcrumbs$map, _breadcrumbsList, _breadcrumbsList2;
  var data = _ref.data,
    isLoading = _ref.isLoading,
    isError = _ref.isError,
    displayMeta = _ref.displayMeta,
    breadcrumbs = _ref.breadcrumbs,
    hotelsList = _ref.hotelsList,
    _ref$showBreadcrumbs = _ref.showBreadcrumbs,
    showBreadcrumbs = _ref$showBreadcrumbs === void 0 ? false : _ref$showBreadcrumbs,
    hotel = _ref.hotel,
    _ref$noIndexNoFollow = _ref.noIndexNoFollow,
    noIndexNoFollow = _ref$noIndexNoFollow === void 0 ? false : _ref$noIndexNoFollow,
    destinationCoordinates = _ref.destinationCoordinates,
    countryCodeISO = _ref.countryCodeISO,
    hotelAvailability = _ref.hotelAvailability,
    roomTypeInformation = _ref.roomTypeInformation;
  var _useFeatureToggle = useFeatureToggle(),
    isHreflangAttributeEnabled = _useFeatureToggle[FT_PI_HREFLANG_ATTRIBUTE];
  var _useCustomLocale = useCustomLocale(),
    country = _useCustomLocale.country,
    language = _useCustomLocale.language;
  var isSEOBreadcrumbEnabled = useFeatureSwitch({
    featureSwitchKey: FS_ENABLE_SEO_BREADCRUMB_PI,
    fallbackValue: false
  });
  var isWindowDefined = typeof window !== 'undefined';
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    origin = _useState2[0],
    setOrigin = _useState2[1];
  useEffect(() => {
    var _window;
    setOrigin((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin);
  }, [isWindowDefined]);
  var router = useRouter();
  var pageTitle = data.pageTitle,
    pageDescription = data.pageDescription,
    cardImageUrl = data.cardImageUrl,
    faviconUrl = data.faviconUrl,
    icons = data.icons,
    msIcons = data.msIcons,
    faq = data.faq,
    hreflangs = data.hreflangs,
    geoJsonLd = data.geoJsonLd;
  if (isLoading || isError) {
    return null;
  }
  var breadcrumbsList = (_breadcrumbs$map = breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map((breadcrumbItem, index) => _objectSpread(_objectSpread({}, breadcrumbItem), {}, {
    position: index + 1
  }))) !== null && _breadcrumbs$map !== void 0 ? _breadcrumbs$map : [];
  var hasBreadcrumbs = breadcrumbsList && ((_breadcrumbsList = breadcrumbsList) === null || _breadcrumbsList === void 0 ? void 0 : _breadcrumbsList.length) > 0;
  if (hasBreadcrumbs && !((_breadcrumbsList2 = breadcrumbsList[breadcrumbsList.length - 1]) !== null && _breadcrumbsList2 !== void 0 && _breadcrumbsList2.link)) {
    breadcrumbsList = breadcrumbsList.slice(0, -1);
  }
  return _jsxs(Head, {
    children: [_jsx("title", {
      children: pageTitle
    }), _jsx("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1"
    }), displayMeta && _jsxs(_Fragment, {
      children: [_jsx("meta", {
        name: "description",
        content: pageDescription
      }), noIndexNoFollow ? _jsx("meta", {
        name: "robots",
        content: "noindex,nofollow"
      }) : _jsx("meta", {
        name: "robots",
        content: "index,follow"
      }), _jsx("meta", {
        property: "twitter:card",
        content: "summary"
      }), _jsx("meta", {
        property: "twitter:url",
        content: getCurrentPageURL()
      }), _jsx("meta", {
        property: "twitter:title",
        content: pageTitle
      }), _jsx("meta", {
        property: "twitter:description",
        content: pageDescription
      }), _jsx("meta", {
        property: "twitter:image",
        content: cardImageUrl
      }), _jsx("meta", {
        property: "twitter:site",
        content: "Premier Inn"
      }), _jsx("meta", {
        property: "twitter:creator"
      }), _jsx("meta", {
        property: "og:type",
        content: "website"
      }), _jsx("meta", {
        property: "og:url",
        content: getCurrentPageURL()
      }), _jsx("meta", {
        property: "og:title",
        content: pageTitle
      }), _jsx("meta", {
        property: "og:description",
        content: pageDescription
      }), _jsx("meta", {
        property: "og:image",
        content: cardImageUrl
      }), _jsx("meta", {
        property: "og:site_name",
        content: "Premier Inn"
      }), _jsx("meta", {
        property: "fb:admins"
      }), _jsx("meta", {
        name: "msapplication-TileColor",
        content: "#552462"
      }), renderItems(msIcons, icon => _jsx("meta", {
        name: icon.name,
        content: icon.content
      }, icon.name)), isHreflangAttributeEnabled && renderItems(hreflangs, _ref2 => {
        var hreflang = _ref2.hreflang,
          href = _ref2.href;
        return _jsx("link", {
          rel: "alternate",
          hrefLang: hreflang,
          href: href
        }, hreflang);
      }), renderItems(icons, icon => _jsx("link", {
        rel: icon.rel,
        sizes: icon.sizes,
        href: formatAssetsUrl(icon.href)
      }, icon.href))]
    }), _jsx("link", {
      rel: "icon",
      type: "image/x-icon",
      href: formatAssetsUrl(faviconUrl)
    }), _jsx("link", {
      rel: "canonical",
      href: getCanonicalURL(router.locale, hreflangs)
    }), renderGraph(hotelAvailability, roomTypeInformation)]
  });
  function renderGraph(dataHotelAvailabilityPI, dataRoomTypeInformation) {
    var _faq$faqItems3;
    if (showBreadcrumbs) {
      var _getCanonicalURL, _breadcrumbs$title, _breadcrumbs, _faq$faqItems, _faq$faqItems2;
      var dlpGraph = [];
      var pageUrl = (_getCanonicalURL = getCanonicalURL(router.locale, hreflangs)) !== null && _getCanonicalURL !== void 0 ? _getCanonicalURL : '';
      var baseUrl = origin || (pageUrl ? new URL(pageUrl).origin : '');
      var destinationName = (_breadcrumbs$title = breadcrumbs === null || breadcrumbs === void 0 || (_breadcrumbs = breadcrumbs[breadcrumbs.length - 1]) === null || _breadcrumbs === void 0 ? void 0 : _breadcrumbs.title) !== null && _breadcrumbs$title !== void 0 ? _breadcrumbs$title : '';
      var hasDlpCoordinates = (destinationCoordinates === null || destinationCoordinates === void 0 ? void 0 : destinationCoordinates.latitude) != null && (destinationCoordinates === null || destinationCoordinates === void 0 ? void 0 : destinationCoordinates.longitude) != null;
      var mainEntityRefs = [];
      if (hotelsList && hotelsList.length > 0) {
        mainEntityRefs.push({
          '@id': "".concat(pageUrl, "/#itemlist")
        });
      }
      if ((faq === null || faq === void 0 || (_faq$faqItems = faq.faqItems) === null || _faq$faqItems === void 0 ? void 0 : _faq$faqItems.length) > 0) {
        mainEntityRefs.push({
          '@id': "".concat(pageUrl, "/#faq")
        });
      }
      dlpGraph.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        '@type': 'WebPage',
        '@id': "".concat(pageUrl, "/#webpage"),
        url: pageUrl,
        name: pageTitle
      }, hasBreadcrumbs && {
        breadcrumb: {
          '@id': "".concat(pageUrl, "/#breadcrumb")
        }
      }), mainEntityRefs.length > 0 && {
        mainEntity: mainEntityRefs
      }), hasDlpCoordinates && {
        about: {
          '@id': "".concat(pageUrl, "/#place")
        }
      }), {}, {
        inLanguage: "".concat(language, "-").concat(country.toUpperCase())
      }));
      if (hasDlpCoordinates) {
        dlpGraph.push({
          '@type': 'City',
          '@id': "".concat(pageUrl, "/#place"),
          name: destinationName,
          geo: {
            '@type': 'GeoCoordinates',
            latitude: destinationCoordinates === null || destinationCoordinates === void 0 ? void 0 : destinationCoordinates.latitude,
            longitude: destinationCoordinates === null || destinationCoordinates === void 0 ? void 0 : destinationCoordinates.longitude
          },
          address: {
            '@type': 'PostalAddress',
            addressCountry: countryCodeISO
          }
        });
      }
      if (hotelsList && hotelsList.length > 0) {
        dlpGraph.push({
          '@type': 'ItemList',
          '@id': "".concat(pageUrl, "/#itemlist"),
          name: pageTitle,
          numberOfItems: hotelsList.length,
          itemListElement: hotelsList.map((h, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            item: formatHotelForList(h, baseUrl)
          }))
        });
      }
      if ((faq === null || faq === void 0 || (_faq$faqItems2 = faq.faqItems) === null || _faq$faqItems2 === void 0 ? void 0 : _faq$faqItems2.length) > 0) {
        dlpGraph.push({
          '@type': 'FAQPage',
          '@id': "".concat(pageUrl, "/#faq"),
          mainEntity: faq.faqItems.map(item => {
            var _item$question, _item$answer;
            return {
              '@type': 'Question',
              name: (_item$question = item.question) !== null && _item$question !== void 0 ? _item$question : '',
              acceptedAnswer: {
                '@type': 'Answer',
                text: removeHtmlTags((_item$answer = item.answer) !== null && _item$answer !== void 0 ? _item$answer : '').replace(/(\r\n|\n|\r)/gm, ' ').trim()
              }
            };
          })
        });
      }
      if (hasBreadcrumbs) {
        dlpGraph.push({
          '@type': 'BreadcrumbList',
          '@id': "".concat(pageUrl, "/#breadcrumb"),
          itemListElement: breadcrumbsList.map(b => ({
            '@type': 'ListItem',
            position: b.position,
            name: b.title,
            item: formatAssetsUrl(b.link)
          }))
        });
      }
      if (geoJsonLd) {
        try {
          var jsonLdFragment = "{".concat(geoJsonLd.trim(), "}");
          dlpGraph.push(JSON.parse(jsonLdFragment));
        } catch (error) {
          console.warn('Invalid geoJsonLd fragment', geoJsonLd.toString(), error);
        }
      }
      if (dlpGraph.length === 0) return null;
      return _jsx("script", {
        "data-testid": "seoGraph",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': dlpGraph
          })
        }
      });
    }
    var hdpGraph = [];
    if (hasBreadcrumbs && isSEOBreadcrumbEnabled) {
      hdpGraph.push({
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbsList.map(b => ({
          '@type': 'ListItem',
          position: b.position,
          name: b.title,
          item: formatAssetsUrl(b.link)
        }))
      });
    }
    if (hotel) {
      var _hotel$seo, _hotel$hotelFacilitie, _hotel$hotelId, _hotel$checkInTime, _hotel$checkInTime2, _hotel$links;
      if ((_hotel$seo = hotel.seo) !== null && _hotel$seo !== void 0 && _hotel$seo.geoJsonLd) {
        try {
          var _jsonLdFragment = "{".concat(hotel.seo.geoJsonLd.trim(), "}");
          hdpGraph.push(JSON.parse(_jsonLdFragment));
        } catch (error) {
          console.warn('Invalid geoJsonLd fragment', hotel.seo.geoJsonLd.toString(), error);
        }
      }
      var amenityFeature = (_hotel$hotelFacilitie = hotel.hotelFacilities) === null || _hotel$hotelFacilitie === void 0 ? void 0 : _hotel$hotelFacilitie.map(facility => {
        var _facility$name;
        return {
          '@type': 'LocationFeatureSpecification',
          name: (_facility$name = facility.name) !== null && _facility$name !== void 0 ? _facility$name : '',
          value: true
        };
      });
      var formattedHotel = formatHotel(hotel);
      formattedHotel.identifier = (_hotel$hotelId = hotel.hotelId) !== null && _hotel$hotelId !== void 0 ? _hotel$hotelId : '';
      formattedHotel.amenityFeature = amenityFeature;
      formattedHotel.checkinTime = hotel.brand === 'PID' ? "".concat((_hotel$checkInTime = hotel.checkInTime) !== null && _hotel$checkInTime !== void 0 ? _hotel$checkInTime : '15:00:00') : "".concat((_hotel$checkInTime2 = hotel.checkInTime) !== null && _hotel$checkInTime2 !== void 0 ? _hotel$checkInTime2 : '14:00:00');
      formattedHotel.checkoutTime = '12:00:00';
      formattedHotel.priceRange = getPriceRange(dataHotelAvailabilityPI);
      if (dataHotelAvailabilityPI && dataRoomTypeInformation) {
        formattedHotel.containsPlace = containsPlaceLD(dataHotelAvailabilityPI, dataRoomTypeInformation, hotel.brand);
      }
      formattedHotel['@id'] = "".concat(origin, "/").concat(country, "/").concat(language, "/hotels").concat((_hotel$links = hotel.links) === null || _hotel$links === void 0 ? void 0 : _hotel$links.detailsPage, ".html#hotel");
      hdpGraph.push(formattedHotel);
    }
    if ((faq === null || faq === void 0 || (_faq$faqItems3 = faq.faqItems) === null || _faq$faqItems3 === void 0 ? void 0 : _faq$faqItems3.length) > 0) {
      hdpGraph.push({
        '@type': 'FAQPage',
        mainEntity: faq.faqItems.map(item => {
          var _item$question2, _item$answer2;
          return {
            '@type': 'Question',
            name: (_item$question2 = item.question) !== null && _item$question2 !== void 0 ? _item$question2 : '',
            acceptedAnswer: {
              '@type': 'Answer',
              text: removeHtmlTags((_item$answer2 = item.answer) !== null && _item$answer2 !== void 0 ? _item$answer2 : '').replace(/(\r\n|\n|\r)/gm, ' ').trim()
            }
          };
        })
      });
    }
    if (hdpGraph.length === 0) return null;
    return _jsx("script", {
      "data-testid": "seoGraph",
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@graph': hdpGraph
        })
      }
    });
  }
  function formatHotelForList(hotel, baseUrl) {
    var _hotel$links2, _hotel$coordinates, _hotel$coordinates2, _hotel$coordinates3, _hotel$coordinates4, _hotel$coordinates5, _hotel$coordinates6, _ref3, _hotel$contactDetails, _hotel$contactDetails2, _hotel$contactDetails3, _hotel$galleryImages, _hotel$address$cityNa, _hotel$address, _hotel$address2, _hotel$address3, _hotel$address4, _hotel$address5, _hotel$address6, _hotel$address7;
    var hotelUrl = (_hotel$links2 = hotel.links) !== null && _hotel$links2 !== void 0 && _hotel$links2.detailsPage ? "".concat(baseUrl, "/").concat(country, "/").concat(language, "/hotels").concat(hotel.links.detailsPage, ".html") : undefined;
    var hasCoordinates = ((_hotel$coordinates = hotel.coordinates) === null || _hotel$coordinates === void 0 ? void 0 : _hotel$coordinates.latitude) != null && ((_hotel$coordinates2 = hotel.coordinates) === null || _hotel$coordinates2 === void 0 ? void 0 : _hotel$coordinates2.longitude) != null;
    var hasMap = hasCoordinates ? "https://maps.googleapis.com/maps/api/staticmap?sensor=false&zoom=15&size=1600x1200&center=".concat((_hotel$coordinates3 = hotel.coordinates) === null || _hotel$coordinates3 === void 0 ? void 0 : _hotel$coordinates3.latitude, ",").concat((_hotel$coordinates4 = hotel.coordinates) === null || _hotel$coordinates4 === void 0 ? void 0 : _hotel$coordinates4.longitude, "&markers=color:0x511E62%7c").concat((_hotel$coordinates5 = hotel.coordinates) === null || _hotel$coordinates5 === void 0 ? void 0 : _hotel$coordinates5.latitude, ",").concat((_hotel$coordinates6 = hotel.coordinates) === null || _hotel$coordinates6 === void 0 ? void 0 : _hotel$coordinates6.longitude, "&key=").concat(process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY) : undefined;
    return _objectSpread(_objectSpread(_objectSpread({
      '@type': 'Hotel',
      name: hotel.name
    }, hotelUrl && {
      url: hotelUrl
    }), {}, {
      telephone: (_ref3 = (_hotel$contactDetails = (_hotel$contactDetails2 = hotel.contactDetails) === null || _hotel$contactDetails2 === void 0 ? void 0 : _hotel$contactDetails2.hotelNationalPhone) !== null && _hotel$contactDetails !== void 0 ? _hotel$contactDetails : (_hotel$contactDetails3 = hotel.contactDetails) === null || _hotel$contactDetails3 === void 0 ? void 0 : _hotel$contactDetails3.phone) !== null && _ref3 !== void 0 ? _ref3 : ''
    }, hasMap && {
      hasMap
    }), {}, {
      image: ((_hotel$galleryImages = hotel.galleryImages) !== null && _hotel$galleryImages !== void 0 ? _hotel$galleryImages : []).map(image => {
        var _image$imageSrc;
        return formatAssetsUrl((_image$imageSrc = image.imageSrc) !== null && _image$imageSrc !== void 0 ? _image$imageSrc : '').replace('///', '//');
      }),
      description: hotel.hotelDescription ? removeHtmlTags(hotel.hotelDescription).replace(/(\r\n|\n|\r)/gm, ' ').trim() : undefined,
      address: _objectSpread(_objectSpread({
        '@type': 'PostalAddress',
        addressLocality: (_hotel$address$cityNa = (_hotel$address = hotel.address) === null || _hotel$address === void 0 ? void 0 : _hotel$address.cityName) !== null && _hotel$address$cityNa !== void 0 ? _hotel$address$cityNa : (_hotel$address2 = hotel.address) === null || _hotel$address2 === void 0 ? void 0 : _hotel$address2.addressLine2,
        postalCode: (_hotel$address3 = hotel.address) === null || _hotel$address3 === void 0 ? void 0 : _hotel$address3.postalCode,
        streetAddress: [(_hotel$address4 = hotel.address) === null || _hotel$address4 === void 0 ? void 0 : _hotel$address4.addressLine1, (_hotel$address5 = hotel.address) === null || _hotel$address5 === void 0 ? void 0 : _hotel$address5.addressLine3, (_hotel$address6 = hotel.address) === null || _hotel$address6 === void 0 ? void 0 : _hotel$address6.addressLine2].filter(Boolean).join(', ')
      }, ((_hotel$address7 = hotel.address) === null || _hotel$address7 === void 0 ? void 0 : _hotel$address7.addressLine3) && {
        addressRegion: hotel.address.addressLine3
      }), {}, {
        addressCountry: hotel === null || hotel === void 0 ? void 0 : hotel.countryCodeISO
      })
    });
  }
  function formatHotel(hotel) {
    var _hotel$tripAdvisorRev, _hotel$coordinates7, _hotel$coordinates8, _hotel$coordinates9, _hotel$coordinates0, _ref4, _hotel$contactDetails4, _hotel$contactDetails5, _hotel$contactDetails6, _hotel$galleryImages2, _hotel$links3, _hotel$address$cityNa2, _hotel$address8, _hotel$address9, _hotel$address0, _hotel$address1, _hotel$address10, _hotel$address11, _hotel$address12, _hotel$tripAdvisorRev2, _hotel$tripAdvisorRev3, _hotel$coordinates1, _hotel$coordinates10;
    var reviewsRating = hotel === null || hotel === void 0 || (_hotel$tripAdvisorRev = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev === void 0 || (_hotel$tripAdvisorRev = _hotel$tripAdvisorRev.reviews) === null || _hotel$tripAdvisorRev === void 0 ? void 0 : _hotel$tripAdvisorRev.map(review => review.rating);
    var aggregateRating = hotel !== null && hotel !== void 0 && hotel.tripAdvisorReviews ? {
      '@type': 'AggregateRating',
      ratingValue: String(hotel.tripAdvisorReviews.rating),
      bestRating: reviewsRating && String(Math.max(hotel.tripAdvisorReviews.rating, ...reviewsRating)),
      ratingCount: String(hotel.tripAdvisorReviews.numberOfReviews)
    } : undefined;
    return _objectSpread(_objectSpread({
      '@type': 'Hotel',
      hasMap: "https://maps.googleapis.com/maps/api/staticmap?sensor=false&zoom=15&size=1600x1200&center=".concat((_hotel$coordinates7 = hotel.coordinates) === null || _hotel$coordinates7 === void 0 ? void 0 : _hotel$coordinates7.latitude, ",").concat((_hotel$coordinates8 = hotel.coordinates) === null || _hotel$coordinates8 === void 0 ? void 0 : _hotel$coordinates8.longitude, "&markers=color:0x511E62%7c").concat((_hotel$coordinates9 = hotel.coordinates) === null || _hotel$coordinates9 === void 0 ? void 0 : _hotel$coordinates9.latitude, ",").concat((_hotel$coordinates0 = hotel.coordinates) === null || _hotel$coordinates0 === void 0 ? void 0 : _hotel$coordinates0.longitude, "&key=").concat(process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY),
      name: hotel.name,
      telephone: (_ref4 = (_hotel$contactDetails4 = (_hotel$contactDetails5 = hotel.contactDetails) === null || _hotel$contactDetails5 === void 0 ? void 0 : _hotel$contactDetails5.hotelNationalPhone) !== null && _hotel$contactDetails4 !== void 0 ? _hotel$contactDetails4 : (_hotel$contactDetails6 = hotel.contactDetails) === null || _hotel$contactDetails6 === void 0 ? void 0 : _hotel$contactDetails6.phone) !== null && _ref4 !== void 0 ? _ref4 : '',
      image: ((_hotel$galleryImages2 = hotel.galleryImages) !== null && _hotel$galleryImages2 !== void 0 ? _hotel$galleryImages2 : []).map(image => {
        var _image$imageSrc2;
        return formatAssetsUrl((_image$imageSrc2 = image.imageSrc) !== null && _image$imageSrc2 !== void 0 ? _image$imageSrc2 : '').replace('///', '//');
      }),
      description: hotel.hotelDescription ? removeHtmlTags(hotel.hotelDescription).replace(/(\r\n|\n|\r)/gm, ' ').trim() : undefined,
      url: "".concat(origin, "/").concat(country, "/").concat(language, "/hotels").concat((_hotel$links3 = hotel.links) === null || _hotel$links3 === void 0 ? void 0 : _hotel$links3.detailsPage, ".html"),
      address: _objectSpread(_objectSpread({
        '@type': 'PostalAddress',
        addressLocality: (_hotel$address$cityNa2 = (_hotel$address8 = hotel.address) === null || _hotel$address8 === void 0 ? void 0 : _hotel$address8.cityName) !== null && _hotel$address$cityNa2 !== void 0 ? _hotel$address$cityNa2 : (_hotel$address9 = hotel.address) === null || _hotel$address9 === void 0 ? void 0 : _hotel$address9.addressLine2,
        postalCode: (_hotel$address0 = hotel.address) === null || _hotel$address0 === void 0 ? void 0 : _hotel$address0.postalCode,
        streetAddress: [(_hotel$address1 = hotel.address) === null || _hotel$address1 === void 0 ? void 0 : _hotel$address1.addressLine1, (_hotel$address10 = hotel.address) === null || _hotel$address10 === void 0 ? void 0 : _hotel$address10.addressLine3, (_hotel$address11 = hotel.address) === null || _hotel$address11 === void 0 ? void 0 : _hotel$address11.addressLine2].filter(Boolean).join(', ')
      }, ((_hotel$address12 = hotel.address) === null || _hotel$address12 === void 0 ? void 0 : _hotel$address12.addressLine3) && {
        addressRegion: hotel.address.addressLine3
      }), {}, {
        addressCountry: hotel === null || hotel === void 0 ? void 0 : hotel.countryCodeISO
      }),
      review: ratingFormatter((_hotel$tripAdvisorRev2 = (_hotel$tripAdvisorRev3 = hotel.tripAdvisorReviews) === null || _hotel$tripAdvisorRev3 === void 0 ? void 0 : _hotel$tripAdvisorRev3.reviews) !== null && _hotel$tripAdvisorRev2 !== void 0 ? _hotel$tripAdvisorRev2 : [])
    }, aggregateRating && {
      aggregateRating
    }), {}, {
      geo: {
        '@type': 'GeoCoordinates',
        latitude: (_hotel$coordinates1 = hotel.coordinates) === null || _hotel$coordinates1 === void 0 ? void 0 : _hotel$coordinates1.latitude,
        longitude: (_hotel$coordinates10 = hotel.coordinates) === null || _hotel$coordinates10 === void 0 ? void 0 : _hotel$coordinates10.longitude
      }
    });
  }
  function getCurrentPageURL() {
    var _window$location;
    return typeof window !== 'undefined' ? (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.href : '';
  }
}
function renderItems(items, callbackFn) {
  return items && (items === null || items === void 0 ? void 0 : items.length) > 0 && items.map(callbackFn);
}
function getCanonicalURL(country, hreflangs) {
  var _hreflangs$find;
  var language = country === 'gb' ? 'en' : 'de';
  return hreflangs === null || hreflangs === void 0 || (_hreflangs$find = hreflangs.find(hreflang => hreflang.hreflang.includes("".concat(language, "-").concat(country)))) === null || _hreflangs$find === void 0 ? void 0 : _hreflangs$find.href;
}
function ratingFormatter(ratings) {
  return ratings.map(ratingItem => {
    var _ratingItem$text, _ratingItem$user$user, _ratingItem$user;
    return {
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: ratingItem.rating
      },
      reviewBody: ((_ratingItem$text = ratingItem.text) !== null && _ratingItem$text !== void 0 ? _ratingItem$text : '').replaceAll('"', ''),
      datePublished: ratingItem.publishedDate,
      author: {
        '@type': 'Person',
        name: (_ratingItem$user$user = ratingItem === null || ratingItem === void 0 || (_ratingItem$user = ratingItem.user) === null || _ratingItem$user === void 0 ? void 0 : _ratingItem$user.username) !== null && _ratingItem$user$user !== void 0 ? _ratingItem$user$user : ''
      }
    };
  });
}